import React, { useCallback, useMemo } from 'react';
import { CardView } from 'design-system/CardView';
import Section from 'design-system/Section';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { uploadTransactionReceipts } from 'actions';
import { selectUserId } from 'reducers/selectors';
import { selectIsDefaultSpace } from 'features/spaces/reducers/selectors';
import TransactionTagsItem from './TransactionTagsItem';
import TransactionNotesItem from './TransactionNotesItem';
import TransactionSplitItem from './TransactionSplitItem';
import TransactionDeleteItem from './TransactionDeleteItem';
import TransactionHelpSection from './TransactionHelpSection';
import TransactionReceiptItem from './TransactionReceiptItem';
import TransactionCashbackSection from './TransactionCashbackSection';
import TransactionShareSection from './TransactionShareSection';
import TransactionExcludedSection from './TransactionExcludedSection';
import TransactionOriginalDateItem from './TransactionOriginalDateItem';
import TransactionSubscriptionSection from './TransactionSubscriptionSection';
import TransactionMerchantHistorySection from './TransactionMerchantHistorySection';
import TransactionLinkedTransactionSection from './TransactionLinkedTransactionSection';
import TransactionOriginalTransactionSection from './TransactionOriginalTransactionSection';
import TransactionEditLogoItem from './TransactionEditLogoItem';
import { isWeb } from '../../../../constants';
const TransactionDetailContent = ({ transaction, reward, skipGetSubscription, didRender, onTagsEdit, }) => {
    const myId = useAppSelector(selectUserId);
    const isDefaultSpace = useAppSelector(selectIsDefaultSpace);
    const isMyTransaction = isDefaultSpace || myId === transaction.userId;
    const dispatch = useAppDispatch();
    const onUploadReceipt = useCallback((transactionId, body, files) => dispatch(uploadTransactionReceipts(transactionId, body, files)), []);
    const hideSuggestMerchant = transaction.isPending;
    const UpperContent = useMemo(() => (<>
        <TransactionOriginalDateItem transaction={transaction}/>
        <TransactionTagsItem transaction={transaction} onTagsEdit={onTagsEdit}/>
        <TransactionNotesItem transaction={transaction}/>
        <TransactionReceiptItem transaction={transaction} onUpload={onUploadReceipt}/>
        <TransactionSplitItem transaction={transaction}/>
        {!hideSuggestMerchant && (<TransactionEditLogoItem transaction={transaction}/>)}
        {isMyTransaction ? (<TransactionDeleteItem transaction={transaction}/>) : null}
      </>), [
        transaction,
        onUploadReceipt,
        isMyTransaction,
        hideSuggestMerchant,
        onTagsEdit,
    ]);
    return (<>
      <Section>
        <CardView noMarginTop noMarginBottom webPadding={isWeb}>
          {UpperContent}
        </CardView>
      </Section>
      {!!didRender && (<>
          {!isWeb && <TransactionCashbackSection reward={reward}/>}
          {isMyTransaction ? (<TransactionShareSection transaction={transaction}/>) : null}
          <TransactionLinkedTransactionSection transaction={transaction}/>
          <TransactionOriginalTransactionSection transaction={transaction}/>
          <TransactionSubscriptionSection transaction={transaction} skipGetSubscription={skipGetSubscription}/>
          <TransactionMerchantHistorySection transaction={transaction}/>
          <TransactionExcludedSection transaction={transaction}/>
          <TransactionHelpSection transaction={transaction}/>
        </>)}
    </>);
};
export default TransactionDetailContent;
